import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import faker from '@faker-js/faker';

import { BackgroundImage, Flex, Text, ProgressBar } from 'Components/Base';
import { get as getTheme } from 'Components/Base/constants';

const CardContainer = styled((props) => (
  <Flex as={'a'} width={1} mt={3} alignItems={'center'} height={'104px'} {...props} />
))`
  border: 1px solid #d9d9d9;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
`;

const CourseImage = styled(BackgroundImage)`
  margin-left: ${getTheme('space.4')}px;
  padding: ${getTheme('space.0')}px;
  background-position: top center;
  min-width: 128px;
  width: 128px;
  height: 72px;
  border-radius: 6px;
`;

const CardDetailsContainer = styled((props) => (
  <Flex pl={3} width={1} flexDirection={'column'} justifyContent={'space-between'} {...props} />
))`
  overflow: hidden;
  height: 100%;
`;

const CardTitle = styled((props) => <Text color={'text'} pt={4} {...props} />)`
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
`;

const CardDetails = ({ title, progress, progressLabel }) => {
  return (
    <CardDetailsContainer>
      <CardTitle>{title}</CardTitle>
      <ProgressBar
        pb={4}
        pr={7}
        value={progress}
        label={progressLabel}
        textProps={{
          fontWeight: 300,
          fontSize: '12px',
        }}
        labelPosition={ProgressBar.LABEL_POSITION.BOTTOM}
      />
    </CardDetailsContainer>
  );
};

const CourseCardHorizontalWithProgress = ({
  imageUrl,
  defaultImageUrl,
  title,
  onClick,
  progress,
  containerProps,
  name,
}) => {
  const { t } = useTranslation('products');

  return (
    <Fragment>
      <CardContainer data-testid={`${name}-open`} p={0} onClick={onClick} {...containerProps}>
        <CourseImage src={imageUrl || defaultImageUrl} />
        <CardDetails
          title={title}
          progress={progress}
          progressLabel={t('COURSE_CARD.PROGRESS_SUFFIX')}
        />
      </CardContainer>
    </Fragment>
  );
};

CourseCardHorizontalWithProgress.propTypes = {
  imageUrl: PropTypes.string,
  defaultImageUrl: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  progress: PropTypes.number,
  name: PropTypes.string,
};

CourseCardHorizontalWithProgress.defaultProps = {
  onClick: () => {},
  name: faker.random.uuid(),
};

export default CourseCardHorizontalWithProgress;
